export default __webpack_public_path__ + "images/call-to-action-image.b98fe619251e6e703167653455b7452e.png";